import $ from 'jquery';

export default function pdpGen() {
	
	$('.c-abShipping').click(function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $("#delivery").offset().top
        }, 2000);
    });

    $('.js-productDesc').on("click", function () {
        $(this).next().slideToggle();
        $(this).toggleClass('open');
        $(this).next().toggleClass('is-open');
    });

    $('.c-popupClose').on("click", function() {
        $('.c-popup').removeClass('open');
        $('.c-popupOverlay').removeClass('open');
        $('.jsBisError').hide();
        $('.jsBisSuc').hide();
    });

}

$('#addCartBtn').click(function(){
    $('.js-express-button').addClass('is-active')
    $('#addCartBtn, .sticky-add-to-cart__button').addClass('is-hide')
    $('.js-pdp-checkout').addClass('is-show')
    
    $('.variant').click(function(){
        if($('.js-express-button').hasClass('is-active')){
            $('.js-express-button').removeClass('is-active')
            $('#addCartBtn, .sticky-add-to-cart__button').removeClass('is-hide')
            $('.js-pdp-checkout').removeClass('is-show')
        }
    })

    $('.js-gift-variant').each(function () {
      $(this).click(function () {
        $('#addCartBtn, .sticky-add-to-cart__button').removeClass('is-hide')
        $('.js-pdp-checkout').removeClass('is-show')
      })
    })
})